/** @format */
import * as yup from "yup";



export const aboutSchema = yup.object().shape({
  about: yup.string().required("Description is required"),

});
